module.exports = __webpack_public_path__ + "img/art14.88fc13eb.png";